import Vue from "vue";
import Vuex from "vuex";
// import axios from '@/axios-auth';

import user from "@/store/modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    user
  }
});
